module.exports = __webpack_public_path__ + "media/images/springbig_leaf_logo-c2ad5550.png";